// extracted by mini-css-extract-plugin
export var col = "index-module--col--pG5qf";
export var col0 = "index-module--col0--RX9UN index-module--col--pG5qf";
export var cols = "index-module--cols--HukjN flex";
export var gathering = "index-module--gathering--7Cspx index-module--cols--HukjN flex";
export var gatheringImg = "index-module--gatheringImg--ljuQb index-module--col--pG5qf util-module--doubleImg--2e5kf";
export var iconWrap = "index-module--iconWrap--sxACO util-module--iconWrap--a7crv flex";
export var maxMd = "(max-width: 48em)";
export var section = "index-module--section--gM0Tp section";